import { Hammer, Workflow, TrendingUp } from "lucide-react";

const PILLARS = [
  {
    n: "01",
    icon: Hammer,
    name: "Build",
    head: "Websites & stores that look premium and convert.",
    body: "Fast, mobile-first websites, WooCommerce stores and landing pages — engineered around the way your customers actually buy.",
    items: ["Custom websites", "WooCommerce stores", "Landing pages", "Brand UI"],
  },
  {
    n: "02",
    icon: Workflow,
    name: "Automate",
    head: "Remove the manual work. Forever.",
    body: "We connect your forms, CRM, WhatsApp, email and ops with n8n, Make.com and custom AI agents — so your team can stop copy-pasting.",
    items: ["WhatsApp automation", "CRM setup", "AI workflows", "n8n & Make"],
  },
  {
    n: "03",
    icon: TrendingUp,
    name: "Grow",
    head: "Compounding revenue, not vanity traffic.",
    body: "SEO, local SEO, paid acquisition and lifecycle marketing — all measured in pipeline and revenue, not impressions.",
    items: ["SEO & Local SEO", "Lead generation", "Email marketing", "CRO"],
  },
];

export default function Pillars() {
  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="py-16 md:py-24 border-b hairline"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 items-end mb-10 md:mb-12">
          <div className="col-span-12 md:col-span-7">
            <div className="section-label mb-4">
              <span className="dot" /> The CyberCart Operating System
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-medium leading-[1.05] text-balance">
              One partner. Three jobs. <br />
              <span className="font-serif-accent italic font-normal">
                Build. Automate. Grow.
              </span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:pl-10">
            <p className="text-base md:text-lg text-[color:var(--ink-2)] max-w-md">
              Most agencies do one of these well. We've engineered our team to
              do all three — so the website talks to the CRM, the CRM talks to
              WhatsApp, and your growth doesn't depend on five different
              vendors.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3">
          {PILLARS.map((p, idx) => (
            <div
              key={p.name}
              data-testid={`pillar-${p.name.toLowerCase()}`}
              className={`p-8 md:p-10 border hairline ${
                idx > 0 ? "md:-ml-px" : ""
              } -mt-px md:mt-0 bg-[color:var(--bg)] hover:bg-white transition-colors`}
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-sm tracking-[0.3em] text-[color:var(--ink-2)]">
                  {p.n}
                </span>
                <p.icon className="w-5 h-5 text-[color:var(--ink-2)]" />
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-medium tracking-tight mt-8">
                {p.name}
                <span className="text-[color:var(--accent)]">.</span>
              </h3>
              <p className="mt-3 text-[color:var(--ink)] font-medium text-lg">
                {p.head}
              </p>
              <p className="mt-3 text-[color:var(--ink-2)] leading-relaxed">
                {p.body}
              </p>
              <ul className="mt-6 grid grid-cols-2 gap-y-2 text-sm">
                {p.items.map((it) => (
                  <li
                    key={it}
                    className="flex items-center gap-2 text-[color:var(--ink-2)]"
                  >
                    <span className="dot" /> {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
